import React from 'react';
import { alpha } from '@mui/material/styles';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useTranslation } from '../app/LanguageContext';

/**
 * Full-viewport blocking overlay (e.g. form submit, global save).
 */
export function SavingOverlay({ open, messageKey = 'common.saving' }) {
  const { translate } = useTranslation();
  return (
    <Backdrop
      sx={(theme) => ({
        color: '#fff',
        // Above MUI Dialog (modal) so upload/save feedback stays visible over dialogs
        zIndex: theme.zIndex.snackbar,
        flexDirection: 'column',
        gap: 2,
      })}
      open={open}
    >
      <CircularProgress color="inherit" />
      <Typography variant="body2" color="inherit">
        {translate(messageKey)}
      </Typography>
    </Backdrop>
  );
}

/**
 * Blocks interaction within a positioned parent (e.g. order line card).
 * Parent should have position: 'relative'.
 */
export function InlineSavingOverlay({ open, children, sx, ...rest }) {
  return (
    <Box sx={{ position: 'relative', ...sx }} {...rest}>
      {children}
      {open ? (
        <Box
          sx={(theme) => ({
            position: 'absolute',
            inset: 0,
            bgcolor: alpha(theme.palette.common.black, 0.28),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2,
            borderRadius: 'inherit',
          })}
        >
          <CircularProgress size={32} />
        </Box>
      ) : null}
    </Box>
  );
}
